const styles = theme => ({
  root:{
    fontSize: '80%',
    [theme.breakpoints.up('sm')]: {
      fontSize: '100%'
    }
  },
  slogo: {
    display: 'inline',
    height: 40,
    marginRight: 5,
    [theme.breakpoints.down('xs')]: {
      display: 'none'
    },
  },
  headerLogo: {
    zIndex: 999,
    display: 'inline',
    position: 'fixed',
    height: 35,
    right: 85,
    top: 32,
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    },
  },
  navButton: {
    zIndex: 9,
    position: 'fixed',
    top: 30,
    right: 30,
    cursor: 'pointer',
    width: '250',
    // '&:focus': {
    //   outline: '1px dashed'
    // }
  },
  navButtonIcon: {
    float: 'right',
    height: 30,
    [theme.breakpoints.up('sm')]: {
      height: 40,
    },
  },
  previewButton: {
    // background: 'rgba(118,66,210,.5)',
    zIndex: 9,
    position: 'fixed',
    top: 30,
    left: 30,
    cursor: 'pointer',
    width: '250',
    '& p': {
      display: 'inline',
      color: 'rgb(255,255,255,1)',
      marginLeft: 7,
    },
    '& img': {
      width: 20,
      verticalAlign: 'middle',
      marginTop: -10
    }
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/components/header/styles.js